import { Divider, Dropdown } from "semantic-ui-react";

import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ArticleMetaData } from "astrid-firestore/src/api/articles/types/ArticleMetaData";
import { isArticleSynced, toArticleValue } from "astrid-firestore/src/api/works/data/workArticleFields";
import getDefaultValues from "astrid-firestore/src/types/getDefaultValues";

import Flex from "../../../../../components/Flex/Flex";
import Form from "../../../../forms/components/Form/Form";
import FormFields from "../../../../forms/components/FormFields/FormFields";
import Button from "../../../../ui/components/Buttons/Button";
import Message from "../../../../ui/components/Messages/Message";
import themeColors from "../../../../ui/constants/themeColors";

import useArticleMetadata from "../../../hooks/useArticleMetadata";

const defaultValues = getDefaultValues(ArticleMetaData);

export default function ArticleEditOverrides({ work, article, publisher }) {
	const { t } = useTranslation();

	const { watch, setValue, formState } = Form.useFormContext();

	const [language, channelIds, type] = watch(["language", "channelIds", "type"]);

	const fields = useArticleMetadata({ publisher });

	const [overrides, setOverrides] = useState(
		fields
			.filter(({ name }) => !isArticleSynced(name, article, work))
			.reduce((acc, { name }) => ({ ...acc, [name]: true }), {}),
	);

	return (
		<>
			<Divider section horizontal>
				{t("overrides", "Overrides")}
			</Divider>

			<Message size="small" info>
				<p>
					{t(
						"articlesOverridesInfo",
						"Articles inherits metadata from the work. Changes made here affect only this article, not the work or other articles.",
					)}
				</p>
			</Message>

			<FormFields
				fields={fields.filter(({ name }) => !overrides || overrides[name] === true)}
				renderLabel={({ name, label }) => (
					<Flex>
						{label}

						{!formState.disabled && (
							<a
								style={{ color: themeColors.GREY, cursor: "pointer" }}
								onClick={() => {
									setValue(name, toArticleValue(name, work[name] || defaultValues[name], type), {
										shouldDirty: true,
									});
									setOverrides((prev) => ({ ...prev, [name]: false }));
								}}
							>
								{t("remove", "Remove")}
							</a>
						)}
					</Flex>
				)}
				language={language}
				channelIds={channelIds}
				type={type}
			/>

			{!formState.disabled && (
				<Dropdown
					trigger={<Button>{t("addOverride", "Add override")}</Button>}
					icon={false}
					floating
					pointing="top left"
					options={fields
						.filter(({ name }) => overrides[name] !== true)
						.map(({ name, label }) => ({
							key: name,
							text: label,
							onClick: () => setOverrides((overrides) => ({ ...overrides, [name]: true })),
						}))
						.sort((a, b) => a.text.localeCompare(b.text))}
				/>
			)}
		</>
	);
}
